import empty from "./empty";
export default empty;


/** WEBPACK FOOTER **
 ** ./src/validators/validEmail.js
 **/